// ABJ demo clone of src/components/washUFluoroscopy/injection_support-2-3-1.js (2.3.1 Epidural, listed under Understanding 2.0).
// Copied verbatim 10/14/26 — copy and header colors pending from Jeff. Route: /abj-demo-injection-2-3-1
import React from "react";
import Container from "react-bootstrap/Container";
import Accordion from "react-bootstrap/Accordion";
import { Nav } from "react-bootstrap";
import "@fortawesome/fontawesome-svg-core/styles.css";
import { HashLink as Link } from "react-router-hash-link";
import YouTube from "react-youtube";

const InjectionSupport2_3_1 = () => {
  const opts = {
    height: "390",
    width: "640",
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 0,
    },
  };

  return (
    <div>
      <div className="w-100">
        <Container>
          <div className="w-100">
            <div className="col-10 m-auto">
              <div className="whiteBackground floatLeft clearLeft legosNewBuild">
                <section>
                  {/* L1 Tile Title Header */}
                  <div className="lego l001 abjHeader175a71 legoMargin5">
                    <h1 className="tileTitle">Epidural Steroid Injection</h1>
                    <hr className="w-100 l001Rule" />
                  </div>
                  {/* End Tile Title Header L1 */}

                  {/* L2 */}
                  <div className="lego l002 legoMargin3">
                    <h2 className="l2Headline">About the Procedure.</h2>
                  </div>
                  {/* End L2 */}

                  {/* L14 Paragraph */}
                  <div className="lego l00paragraph legoMargin3">
                    <p>
                      A mixture of a cortisone and local anesthetic (numbing
                      medication) will be injected into the space around the
                      nerves (epidural space). The anesthetic typically numbs
                      the area for 1-2 hours and may provide some immediate
                      relief. The cortisone medication usually takes 3-5 days to
                      start to take effect and up to two weeks to get the full
                      benefit.
                    </p>

                    <p>
                      This procedure uses a contrast agent, which is a safe
                      substance that makes a part of your body show up more
                      clearly on an X-ray to ensure proper placement of the
                      medicine.
                    </p>
                  </div>
                  {/* End L14 Paragraph */}

                  {/* L11 Image */}
                  <div className="lego l011">
                    <img
                      className="imageW100"
                      src="https://orbit-image-video-bucket.s3.us-east-2.amazonaws.com/26c9088ea4ad16f5415fe8cfda96dfc7.png"
                    />
                  </div>

                  {/* End L11 Image */}

                  {/* L66 Divider Rule */}
                  <div className="lego l066">
                    <hr className="horizonalRule" />
                  </div>
                  {/* End L66 Divider Rule */}

                  {/* L4 Subhead Upper */}
                  <div className="lego l004 legoMargin3">
                    <h2 className="subHeadAllCaps">BEFORE THE PROCEDURE:</h2>
                  </div>
                  {/* End L4 Subhead Upper */}

                  {/* L83 Icon Color Bar New */}
                  <div className="lego l083 legoMargin3">
                    <div className="iconContainer">
                      <img
                        className="icon"
                        src="https://orbit-image-video-bucket.s3.us-east-2.amazonaws.com/fluo_icon_no_meds.svg"
                      />
                    </div>
                    <div className="contentContainer">
                      {/* L14 Paragraph */}
                      <div className="lego l00paragraph legoMargin3">
                        <p>
                          Certain medications* like antiplatelet and
                          anticoagulants{" "}
                          <span className="bold">must be stopped prior</span> to
                          receiving a spinal injection.{" "}
                          <span className="bold italic">
                            Please consult with the prescribing provider
                          </span>{" "}
                          for directions on stopping prior to your injection. In
                          the event your healthcare provider doesn't want
                          medications stopped, contact our office immediately.{" "}
                        </p>

                        <p>
                          <span className="note">
                            *Aspirin (325 mg), Plavix (Clopidogrel), Pradaxa
                            (Dabigatran), Xarelto (Rivaroxaban), Acenocoumarol,
                            Aggregnox, Persantine (Dipyridamole), Arixtra
                            (Fondaparinux), Brilinta (Ticagrelor), Effient
                            (Prasugrel), Fragmin (Dalteparin), Heparin, Lovenox
                            (Enoxaparin), Pletal (Cilostazol), Savaysa
                            (Edoxaban).
                          </span>
                        </p>
                      </div>
                      {/* End L14 Paragraph */}

                      {/* L53 Bullet List */}
                      <div className="lego l053">
                        <ul className="w-100">
                          <li className="w-100">
                            <span className="boldItalic">
                              Do NOT stop any other medication
                            </span>{" "}
                            (blood pressure meds, diabetes meds, etc.).
                          </li>
                          <li className="w-100">
                            <span className="boldItalic">
                              Alert our office if you have any history of
                              allergies to local anesthetics
                            </span>{" "}
                            (such as Novocain or Lidocaine).
                          </li>
                          <li className="w-100">
                            If you have an{" "}
                            <span className="boldItalic">
                              allergy to X-ray contrast dye
                            </span>
                            , please notify your healthcare provider prior to
                            the procedure.
                          </li>
                        </ul>
                      </div>
                      {/* End L53 Bullet List */}
                    </div>
                  </div>
                  {/* End L83 Icon Color Bar New */}

                  {/* L4 Subhead Upper */}
                  <div className="lego l004 legoMargin3">
                    <h2 className="subHeadAllCaps">DAY OF THE PROCEDURE:</h2>
                  </div>
                  {/* End L4 Subhead Upper */}

                  {/* L83 Icon Color Bar New */}
                  <div className="lego l083 legoMargin2">
                    <div className="iconContainer">
                      <img
                        className="icon"
                        src="https://orbit-image-video-bucket.s3.us-east-2.amazonaws.com/fluo_icon_clock.svg"
                      />
                    </div>
                    <div className="contentContainer">
                      <p>
                        <span className="bold italic">
                          Please arrive 30 minutes prior to your injection time
                          for registration.
                        </span>
                        &nbsp;If you arrive more than 15 minutes past your
                        scheduled injection time, your procedure may need to be
                        rescheduled.
                      </p>
                    </div>
                  </div>
                  {/* End L83 Icon Color Bar New */}

                  {/* L4 Subhead Upper */}
                  <div className="lego l004 legoMargin2">
                    <h2 className="subHeadAllCaps">AFTER THE PROCEDURE:</h2>
                  </div>
                  {/* End L4 Subhead Upper */}

                  {/* L83 Icon Color Bar New */}
                  <div className="lego l083 legoMargin2">
                    <div className="iconContainer">
                      <img
                        className="icon"
                        src="https://orbit-image-video-bucket.s3.us-east-2.amazonaws.com/fluo_icon_meds.svg"
                      />
                    </div>
                    <div className="contentContainer">
                      <p>
                        You may&nbsp;
                        <span className="bold italic">
                          resume all medications the day after the procedure
                        </span>
                        , &nbsp;including blood thinners/anti-coagulants.
                      </p>
                    </div>
                  </div>
                  {/* End L83 Icon Color Bar New */}

                  {/* L83 Icon Color Bar New */}
                  <div className="lego l083 legoMargin2">
                    <div className="iconContainer">
                      <img
                        className="icon"
                        src="https://orbit-image-video-bucket.s3.us-east-2.amazonaws.com/fluo_icon_writ_instruct.svg"
                      />
                    </div>
                    <div className="contentContainer">
                      <p>
                        You will be given written discharge instructions after
                        your procedure along with a pain diary to track your
                        response to the injection.
                      </p>
                    </div>
                  </div>
                  {/* End L83 Icon Color Bar New */}

                  {/* L83 Icon Color Bar New */}
                  <div className="lego l083 legoMargin2">
                    <div className="iconContainer">
                      <img
                        className="icon"
                        src="https://orbit-image-video-bucket.s3.us-east-2.amazonaws.com/fluo_icon_no_bath.svg"
                      />
                    </div>
                    <div className="contentContainer">
                      <p>
                        Stay out of a pool, bath or hot tub for two days after
                        the procedure.
                        <br />
                        <span className="boldItalic">Showers are OK.</span>
                      </p>
                    </div>
                  </div>
                  {/* End L83 Icon Color Bar New */}

                  {/* L83 Icon Color Bar New */}
                  <div className="lego l083 legoMargin3">
                    <div className="iconContainer">
                      <img
                        className="icon"
                        src="https://orbit-image-video-bucket.s3.us-east-2.amazonaws.com/fluo_icon_no_driving.svg"
                      />
                    </div>
                    <div className="contentContainer">
                      <p>
                        <span className="boldItalic">
                          Please consider having someone drive you.
                        </span>
                        <br />
                        The anesthetic may cause temporary numbness.
                      </p>
                    </div>
                  </div>
                  {/* End L83 Icon Color Bar New */}

                  {/* L85 Color Bar Top Content Block */}
                  <div className="lego l085">
                    <div className="headerColorBar">
                      <h3>Vaccinations and your Steroid Injection</h3>
                    </div>
                    <div className="contentContainer">
                      <p>
                        To ensure effectiveness of your COVID-19 vaccine,
                        COVID-19 booster, Flu vaccine, and any other vaccine and
                        to improve your ability to monitor potential side
                        effects,{" "}
                        <span className="boldItalic">
                          you should speak with your provider if:
                        </span>
                      </p>
                      <ul>
                        <li>You had the vaccine in the last 2 weeks.</li>
                        <li>You plan to have the vaccine.</li>
                        <li>You are immunocompromised.</li>
                      </ul>
                    </div>
                  </div>
                  {/* End L85 Color Bar Top Content Block */}

                  {/* L66 Divider Rule */}
                  <div className="lego l066">
                    <hr className="horizonalRule" />
                  </div>
                  {/* End L66 Divider Rule */}

                  {/* L4 Subhead Upper */}
                  <div className="lego l004 legoMargin2">
                    <h2 className="subHeadAllCaps">WHEN YOU GET HOME</h2>
                  </div>
                  {/* End L4 Subhead Upper */}

                  {/* L14 Paragraph */}
                  <div className="lego l00paragraph legoMargin5 w-80 m-auto">
                    <p>
                      For questions during normal working hours, call our office
                      at&nbsp;
                      <span className="bold">
                        <a className="phoneLink" href="tel:5555550100">
                          555-555-0100.
                        </a>
                      </span>
                      <br />
                      <span className="bold">
                        For urgent concerns after hours
                      </span>
                      , call our exchange at{" "}
                      <span className="bold">
                        <a className="phoneLink" href="tel:5555550101">
                          555-555-0101
                        </a>
                        .
                      </span>
                    </p>
                  </div>
                  {/* End L14 Paragraph */}

                  {/* L84 Block */}
                  <div className="lego l084 legoMargin5">
                    <h3 className="contentTitle">
                      Billing for Injection Procedures
                    </h3>
                    <p>
                      Our orthopedic specialists treat
                      patients at various facilities, which means you may
                      receive two separate bills. One bill is for the physician
                      and the other is for the facility charges.{" "}
                    </p>

                    {/* L82? Content 2 sides 50% width */}
                    <div className="lego l082 p-0">
                      <div className="contentLeftSide">
                        {/* L11 Image */}
                        <div className="lego l011 legoMargin3">
                          <img
                            className="imageW100 noBorderRadius"
                            src="https://orbit-image-video-bucket.s3.us-east-2.amazonaws.com/cbc217ae4fc61ef763bbd58ff2d2040e.png"
                          />
                        </div>
                        {/* End L11 Image */}
                      </div>
                      <div className="contentRightSide">
                        <div className="lego l00paragraph legoMargin1">
                          <p>
                            If you have questions regarding a price estimation
                            for the services or a recently received bill, please
                            contact:
                          </p>
                          <p>
                            Price Estimation:
                            <br />
                            <span className="bold">
                              <a className="phoneLink" href="tel:5555550102">
                                555-555-0102
                              </a>
                            </span>
                          </p>
                          <p>
                            Patient Services:
                            <br />
                            <span className="bold">
                              <a className="phoneLink" href="tel:5555550103">
                                555-555-0103
                              </a>
                            </span>
                          </p>
                          <p>
                            Patient Billing Services:
                            <br />
                            <span className="bold">
                              <a className="phoneLink" href="tel:5555550102">
                                555-555-0102
                              </a>
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                    {/* End L82? Content 2 sides 50% width */}
                  </div>
                  {/* End L84 Block */}
                </section>
              </div>

              {/* TO-1802: trimmed "Your Hospital Stay" from TGSP 2.5, appended for the demo */}
              <div className="whiteBackground floatLeft clearLeft">
                <section>
                  <div className="col-12">
                      <div className="w-100">
                          <h1 className="tileTitleHeader centeredPageHeader text-center abjHeader175a71">Your Hospital Stay</h1>
                      </div>
                  </div>
                  {/* Demo annotation (TO-1802): neither injection procedure has a hospital stay */}
                  <div className="col-12">
                      <div className="w-100">
                          <p className="text-center" style={{color: "#d0021b", fontStyle: "italic", fontWeight: 700}}>Inserted when relevant</p>
                      </div>
                  </div>
                  <div className="col-12">
                      <div className="w-100">
                          <h2 className="subheadUpperandLower text-center floatNone">Your Surgical Care Team</h2>
                      </div>
                  </div>
                  <div className="col-12">
                      <div className="w-100">
                          <p>Your primary surgical team is a group of physicians (medical doctors) and physician extenders that will manage care while you are in the hospital. Your care team members are listed below. At night, a team of physicians are on-call and available for urgent issues.</p>
                      </div>
                  </div>
                  <div className="col-12 questionAndAnswer">
                      <div className="w-100">
                          <Accordion className="moreLess">
                              <Accordion.Item eventKey="0">
                                  <Accordion.Header>MORE &nbsp; <i className="fa fa-chevron-right"></i></Accordion.Header>
                                  <Accordion.Body>
                                      <div className="col-12">
                                          <div className="w-100">
                                              <p className="boldLeadIn">Attending Surgeon</p>
                                              <p>A physician who has completed training. An attending
                                                  physician supervises resident physicians and fellow
                                                  physicians. They are ultimately responsible for your
                                                  care.</p>
                                          </div>
                                      </div>
                                      <div className="col-12">
                                          <div className="w-100">
                                              <p className="boldLeadIn">Fellows</p>
                                              <p>A physician who has completed medical school and their
                                                  residency. A fellowship is a year of additional training in
                                                  a surgical specialty.</p>
                                          </div>
                                      </div>
                                      <div className="col-12">
                                          <div className="w-100">
                                              <p className="boldLeadIn">Residents</p>
                                              <p>A resident is a physician who has completed their medical
                                                  degree and is now training in their surgical
                                                  specialty. Residents work closely with your attending surgeon in
                                                  the operating room as well as on the hospital floor. They
                                                  will round on you daily and provide post-operative care.</p>
                                          </div>
                                      </div>
                                      <div className="col-12">
                                          <div className="w-100">
                                              <p className="boldLeadIn">Physician Extender</p>
                                              <p>Physician extenders (also known as advanced practice
                                                  providers) are physician assistants or nurse practitioners.
                                                  They work closely with your attending physician and resident
                                                  physicians to manage your care while in the hospital. Your
                                                  physician extender will see you daily and be your main
                                                  contact during your hospital stay.</p>
                                          </div>
                                      </div>
                                      <div className="col-12">
                                          <div className="w-100">
                                              <p className="boldLeadIn">Nurse</p>
                                              <p>You will have nurses who are specialized and have experience
                                                  in caring for patients who have had surgeries
                                                  similar to yours. They will provide care for you during your
                                                  hospitalization as well as provide education to you and your
                                                  caregivers during your stay.</p>
                                          </div>
                                      </div>
                                      <div className="col-12">
                                          <div className="w-100">
                                              <p className="boldLeadIn">Speech-Language Pathologist (SLP)</p>
                                              <p>Speech-language pathologists are professionals trained to
                                                  identify, assess, and rehabilitate your speech and
                                                  swallowing ability. They perform bedside evaluation and
                                                  education as well as radiologic swallow studies. </p>
                                          </div>
                                      </div>
                                      <div className="col-12">
                                          <div className="w-100">
                                              <p className="boldLeadIn">Physical Therapist (PT)</p>
                                              <p>Physical therapists are health care professionals who provide
                                                  services to help you regain or improve your physical
                                                  abilities through exercises, hands-on care, and education.
                                                  It is very important for you to begin moving and walking as
                                                  soon as possible after surgery.</p>
                                          </div>
                                      </div>
                                      <div className="col-12">
                                          <div className="w-100">
                                              <p className="boldLeadIn">Occupational Therapist (OT)</p>
                                              <p>Occupational therapists are health care professionals who
                                                  provide services designed to restore your self-care, work,
                                                  and leisure skills.</p>
                                          </div>
                                      </div>
                                      <div className="col-12">
                                          <div className="w-100">
                                              <p className="boldLeadIn">Dietician</p>
                                              <p>Dieticians are experts making sure you have adequate
                                                  nutrition during your hospital stay and when you go home.
                                                  Dieticians manage all tube feeding regimens for
                                                  patients.</p>
                                          </div>
                                      </div>
                                      <div className="col-12">
                                          <div className="w-100">
                                              <p className="boldLeadIn">Case Manager/Social Worker</p>
                                              <p>These are specially trained professionals who work with you
                                                  and your caregivers to ensure that you have the appropriate
                                                  support following your discharge from the hospital.
                                                  They will assist you in facility placement, transportation needs,
                                                  and arranging home health support and supplies. </p>
                                          </div>
                                      </div>
                                      <div className="less">
                                          <Accordion.Header>LESS &nbsp; <i className="fa fa-chevron-right"></i></Accordion.Header>
                                      </div>
                                  </Accordion.Body>
                              </Accordion.Item>
                          </Accordion>
                      </div>
                  </div>
                  <div className="col-12">
                      <div className="w-100">
                          <h2 className="subheadUpperandLower text-center floatNone">What to expect during your stay</h2>
                      </div>
                  </div>
                  <div className="col-12 video">
                      <div className="">
                          <div className="floatLeft w-100 captionBelow">
                              <img src="https://orbit-image-video-bucket.s3.us-east-2.amazonaws.com/Faux_video_what_to_expect_inpatient.jpg"
                                   className="img-responsive w-100" alt="What to expect as an In-patient"/>
                          </div>
                          <h3 className="videoTitle w-100 text-center text-dark">Watch: <span className="videoTitleTreatment">What to expect as an In-patient</span></h3>
                      </div>
                  </div>
                  <div className="col-12">
                      <div className="w-100">
                          <p>You will see your team of doctors every morning and evening.</p>
                      </div>
                  </div>
                  <div className="l3SubheadUpperAndLowerBodyCopyAndRule">
                      <div className="col-12 subheadAndBullets">
                          <div className="w-100">
                              <ul className="bulletsCustom checkboxBullets colorAccentRedBullets">
                                  <li>If you have questions throughout the day, write them down so you remember to ask your team when they come to visit you.
                                  </li>
                              </ul>
                          </div>
                      </div>
                      <div className="col-12">
                          <div className="w-100">
                              <p>You will begin your stay in the Progressive Care Unit (PCU) or an Intensive Care Unit (ICU) where you will be watched closely by nurses who are specially trained to take care of patients who have had your type of surgery.</p>
                              <p>After a few days you will move to a surgical floor where nurses are also specially trained to take care of patients who have had your type of surgery. </p>
                              <p>If everything goes as expected, you will be in the hospital about 5 to 7 days.</p>
                          </div>
                      </div>
                  </div>
                  <div className="l3SubheadUpperAndLowerBodyCopyAndRule listWithBorder entDiagnosisSurgeryRedBorderColor">
                      <div className="col-12">
                          <div className="w-100">
                              <h2>Medications</h2>
                          </div>
                      </div>
                      <div className="col-12 subheadAndBullets">
                          <div className="w-100">
                              <ul className="bulletsCustom checkboxBullets colorAccentRedBullets">
                                  <li>Bring a list of your current home medications with you to the hospital (do not bring the actual medications; you will not need them).</li>
                                  <li>Your nurse will give you your medications.</li>
                                  <li>Pain medications will be available to you as needed.</li>
                              </ul>
                          </div>
                      </div>
                  </div>
                  <div className="col-12">
                      <div className="w-100">
                          <h2 className="subheadUpperandLower text-center floatNone">Pain</h2>
                      </div>
                  </div>
                  <div className="col-12">
                      <div className="w-100">
                          <p>We will work with you to best manage your pain. We will ask you to rate the pain you feel after surgery on a scale of 1 to 10. It is important to let us know when you first start feeling uncomfortable. Telling us right away will help keep the uncomfortable feeling from getting worse.</p>
                      </div>
                  </div>

                  <div className="col-12">
                      <div className="w-100">
                          <div className="sidbarFill withBodyCopy sidebarFillBackgroundColor noMinHeight backgroundAccentRed ">
                              <h2 className="subheadUpperAndLower">Key Changes You’ll Notice After Surgery.</h2>
                          </div>
                          <div className="withBorder entDiagnosisSurgeryRedBorderColor">
                              <div className="col-12 subheadAndBullets">
                                  <div className="w-100">
                                      <ul className="bulletsCustom checkboxBullets colorAccentRedBullets">
                                          <li>You may have a surgical drain placed to remove fluid and blood from your surgical wounds. This will be removed when the amount of fluid coming out decreases to a level that is safe.</li>
                                          <li>At first, the area around your surgery site will appear swollen and bulky. This usually improves in the first one to two weeks after surgery.</li>
                                      </ul>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div className="col-12 backToTop">
                    <div className="w-100">
                      <p>
                        <a
                          className="specialUseBackToTop"
                          onClick={() =>
                            window.scrollTo({ top: 0, behavior: "smooth" })
                          }
                        >
                          BACK TO TOP{" "}
                        </a>
                      </p>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default InjectionSupport2_3_1;
